import Home from "./Home";
import Members from "./Members";
import NotFound from "./notFound";
import Publications from "./Publications";
import News from "./News";
import ContactUs from "./Contact";
import Group from "./Group";

export default {
  Home,
  Group,
  Members,
  NotFound,
  Publications,
  News,
  ContactUs,
};
